// Wrapper for Bootstrap color picker 3.1.2
import { ComboSlider } from "components/combo_slider";
import { t } from "i18next";
import * as React from "react";
/** CSS class to locate the element that is used to set up the color picker. */
export const BOOTSTRAP_COLORPICKER_CSS_SELECTOR = ".ui-colorpicker2 .colorpicker-element";
export const DEFAULT_SWATCHES = {
    'Blue': '#80cce6',
    'Red': '#e33d4d',
    'Green': '#3ac433',
    'Yellow': '#d7d725',
    'Grey': '#a0a0a0',
    'Purple': '#ca57a4',
};
export class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.state = { value: props.value };
        this.swatches = props.swatches || DEFAULT_SWATCHES;
        this.translatedSwatches = {};
        for (const name in this.swatches) {
            const translatedName = t(["props." + name, "ui." + name, name], name);
            this.translatedSwatches[translatedName] = this.swatches[name];
        }
    }
    componentDidMount() {
        let jqElement = $(this.ref.current);
        let self = this;
        // 1. If adding any event handlers, make sure to remove them
        //    in componentWillUnmount
        // 2. When invoking callbacks with color values, remember convert
        //    color values to lower case, so that colors can be compared.
        jqElement
            .val(this.props.value)
            .colorpicker({
            color: this.state.value,
            popover: {
                placement: "left",
                boundary: "window",
            },
            extensions: [
                {
                    name: 'swatches',
                    options: {
                        colors: this.translatedSwatches,
                        nameAsValues: true,
                    }
                },
                { name: "manualinput" },
                { name: "extrabuttons" },
            ],
        })
            .on('colorpickerChange', function (e) {
            if (e.color) {
                let color = e.color.toString().toLowerCase();
                self.setState({ value: color });
                self.props.onColorChange(color);
            }
        })
            .on('colorpickerHide', function (e) {
            if (e.color) {
                let color = e.color.toString().toLowerCase();
                self.setState({ value: color });
                self.props.onColorEnd(color);
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
        // Only update on props changes.
        if (prevProps.value != this.props.value) {
            let jqElement = $(this.ref.current);
            jqElement.colorpicker('setValue', this.props.value);
        }
    }
    componentWillUnmount() {
        let jqElement = $(this.ref.current);
        let color = jqElement.colorpicker('getValue');
        if (color) {
            this.props.onColorEnd(color.toString().toLowerCase());
        }
        // Hide & Remove event handlers.
        jqElement.off('colorpickerChange');
        jqElement.off('colorpickerHide');
        jqElement.colorpicker('hide');
    }
    renderOld() {
        return React.createElement("div", { className: "ui-colorpicker" },
            React.createElement("input", { ref: this.ref, style: { "borderRightColor": this.state.value } }));
    }
    maybeMapValueToTranslatedSwatchName() {
        const value = this.state.value;
        for (const name in this.translatedSwatches) {
            if (this.translatedSwatches[name] == value) {
                return name;
            }
        }
        return value;
    }
    render() {
        var _a, _b;
        const opacity = this.props.opacity;
        return React.createElement("div", { className: "ui-colorpicker2" },
            React.createElement("div", { ref: this.ref },
                React.createElement("div", { className: "colorpicker-input-addon", style: { "backgroundColor": this.state.value } }),
                React.createElement("input", { className: "d-none" })),
            opacity == undefined
                ? this.maybeMapValueToTranslatedSwatchName()
                : React.createElement(ComboSlider, { key: "opacitySlider", min: ((_a = opacity.range) !== null && _a !== void 0 ? _a : [0, 1])[0], max: ((_b = opacity.range) !== null && _b !== void 0 ? _b : [0, 1])[1], step: 0.01, unit: "%", initialValue: opacity.value, onChange: opacity.onChange, onEnd: opacity.onEnd }));
    }
}
